/**
 * @generated SignedSource<<bb93f8723fcb71a2fe5dbd9b22b0dbbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "PROCESSING" | "WAITING";
export type tasksModelGeneration3DTaskStatusQuery$variables = {
  taskId: number;
};
export type tasksModelGeneration3DTaskStatusQuery$data = {
  readonly modelGeneration3DTaskStatus: {
    readonly completedAt: string | null;
    readonly createdAt: string;
    readonly errorMessage: string | null;
    readonly processingTimeMs: number | null;
    readonly resultUrl: string | null;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  } | null;
};
export type tasksModelGeneration3DTaskStatusQuery = {
  response: tasksModelGeneration3DTaskStatusQuery$data;
  variables: tasksModelGeneration3DTaskStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "concreteType": "ModelGeneration3DTaskStatus",
    "kind": "LinkedField",
    "name": "modelGeneration3DTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processingTimeMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksModelGeneration3DTaskStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tasksModelGeneration3DTaskStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "41f442c32010f879a4175e26fa04bed4",
    "id": null,
    "metadata": {},
    "name": "tasksModelGeneration3DTaskStatusQuery",
    "operationKind": "query",
    "text": "query tasksModelGeneration3DTaskStatusQuery(\n  $taskId: Long!\n) {\n  modelGeneration3DTaskStatus(taskId: $taskId) {\n    taskId\n    state\n    resultUrl\n    errorMessage\n    processingTimeMs\n    createdAt\n    completedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "01dbaef9fec2032482b12c4146af3627";

export default node;
